import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ROUTE_BUILDERS } from '@/config/routes'
import { useResidentDetailWorkflow } from './useResidentDetailWorkflow'
import {
  getReimbursementId,
  REIMBURSEMENT_ID_ROUTE_PARAM,
  type ResidentDetailPageType,
} from '../utils/residentDecoupling'

export function useResidentDetailPage(pageType: ResidentDetailPageType = 'resident-detail') {
  const { applicantId, userId, reimbursementId: reimbursementIdParam } = useParams<{
    applicantId: string
    userId: string
    [REIMBURSEMENT_ID_ROUTE_PARAM]?: string
  }>()
  const navigate = useNavigate()
  const { hash } = useLocation()

  const page = useResidentDetailWorkflow(
    applicantId,
    userId,
    pageType,
    reimbursementIdParam,
  )

  useEffect(() => {
    if (pageType !== 'default-detail' || page.detail.loading) return
    if (!applicantId || !userId) return
    const loadedId = getReimbursementId(page.detail.residentDetail as Record<string, unknown> | null)
    if (loadedId === undefined) return
    if (reimbursementIdParam !== undefined && String(reimbursementIdParam) === String(loadedId)) {
      return
    }
    const target = ROUTE_BUILDERS.DEFAULT_DETAIL(applicantId, userId, loadedId)
    navigate(`${target}${hash}`, { replace: true })
  }, [
    applicantId,
    hash,
    navigate,
    page.detail.loading,
    page.detail.residentDetail,
    pageType,
    reimbursementIdParam,
    userId,
  ])

  return page
}

export type ResidentDetailPageContext = ReturnType<typeof useResidentDetailPage>
